// extracted by mini-css-extract-plugin
module.exports = {"logo_container":"styles_logo_container__3uPKd"};